import { Poppins, Quicksand } from 'next/font/google'
import Image from 'next/image'
import React, { Component } from 'react'
import Breadcrumbs from '../breadcrumb'
import Form from '../education-form'
const popins = Poppins({weight:"500",subsets:['latin']})
const extrapopins = Poppins({weight:"600", subsets:['latin']});
const quickSand = Quicksand({weight:"400",subsets:['latin']})
export default class Mainsec extends Component {
 
    constructor(props){
        super(props);
        this.state={
            showForm: false
        };
        this.formRef = React.createRef();
    }
 
handleFormPopup=()=>{
this.setState({showForm:true});
document.addEventListener('mousedown',this.handleClickOutside);
}
 
handleCloseForm =()=>{
    this.setState({showForm:false})
    document.removeEventListener('mousedown', this.handleClickOutside);
}
 
handleClickOutside=(event)=>{
    if(this.formRef.current && !this.formRef.current.contains(event.target)){
        this.handleCloseForm();
    }
}
  render() {
    return (
        <>
<section className='course-bg'>
    <div className='container'>
<div className='pdt130 mpdt80'>
<div className=''>
<h1 className={`fs-47 cb lh5 mfs-22 tac pdt20 mpdt10 mtac ${extrapopins.className}`}>{this.props.title} {this.props.location1}</h1>
<div className='con-1000 mdf mfjc mfdc mfac'>
     {/* Mobile Device Image */}
 <div className='dn mdb mdf mfac mfjc mpdt20'>
        <Image src={`/course/${this.props.img}.webp`} className="br20" alt={`${this.props.title} Course-Image`} width={"296"} height={"194"} loading='lazy'/>        
 </div>
<p className={`mdn fs-19 cb mt24 mfs14 mlhs20 mmt12 tac mtal ${popins.className}`}>
{this.props.intro}
</p>
<div className={`mt32 df fjc mmt20 `}>
<a href='tel:7825888899'>
<button className={` enrl-btn  ml24 ${extrapopins.className}`}>Enroll Now</button>
</a>
<button className={`dwnld-btn ml30 ${popins.className}`} onClick={this.handleFormPopup}>Get a Free Demo</button>
</div>
</div>
<div className='df fjc pdt30 pdb20'>
{/* Desktop Image */}
    <div className={`mdn`}>
        <Image src={`/course/${this.props.img}.webp`} className="br20" alt={`${this.props.title} Course-Image`} width={"500"} height={"327"} loading='lazy'/>        
 </div>
 {/* Mobile Device Image */}
 {/* <div className='dn mdb'>
        <Image src={`/course/${this.props.img}.webp`} className="br20" alt={`${this.props.title} Course-Image`} width={"296"} height={"194"} loading='lazy'/>        
 </div> */}
 <p className={`dn mdb fs-19 cb mt24 mfs14 mlhs20 mmt12 tac mtal ${popins.className}`}>
{this.props.intro}
</p>
 </div>
</div>
</div>
</div>
</section>
{this.state.showForm && <div ref={this.formRef}><Form closeForm={this.handleCloseForm}/></div>}
<style jsx>
    {`
    .con-1000{
        max-width:1050px;
        width:100%;
        height:100%;
        margin:0 auto;
    }
       .course-bg{
        background-image: url('/course-img/course-head-bg.webp');
        width:100%;
        height: 680px;
        background-size: contain;
        background-repeat: no-repeat;
        background-size: 100% 100%;
    }
    .dwnld-btn{              
        border-radius: 30px;
        padding: 15px 33px 15px 33px;
        
        background-color: transparent;
        color: #FFFFFF;
        cursor: pointer;
        font-size: 19px;
        line-height: 17.5px;
        letter-spacing: 1.25px;
        border: 2px solid #000000;
        transition: all 0.4s linear;
       
    }
    .dwnld-btn:hover{
    
        background-color: #000000;
        color: #FFFFFF;        
    }
    .enrl-btn{        
        border-radius: 30px;
        padding: 15px 36px 15px 36px;
        border: 2px solid #FFFFFF;
        box-sizing: border-box;
        background-color: #181613;
        cursor: pointer;
        font-size: 19px;
        letter-spacing: 1.25px;
        line-height: 17.5px;
        color: #ffffff;      
        transition: all 0.4s linear;
    }
    .enrl-btn:hover{
           background-color: #FFFFFF;
        color: #FFA900;
        border: 2px solid #000000;
    }
    @media only screen and (max-width: 1023px){
       .course-bg{
        background-image: url('/course-img/course-head-bg.webp');
        width:100%;
        height: 100%;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
       
        background-size: 100% 100%;
    }
    .dwnld-btn{                
        border-radius: 15px;
        padding: 5px 12px 5px 12px;
        border: 0.25px solid #000000;
        color: #FFFFFF;
        cursor: pointer;
        font-size: 12px;
        line-height: 10.5px;
        letter-spacing: 0.25px;
          background-color: transparent;
    }
    .enrl-btn{        
        border-radius: 15px;
        padding: 5px 12px 5px 12px;
        border: 0.25px solid #FFFFFF;
        box-sizing: border-box;
       background-color: #181613;
        cursor: pointer;
        font-size: 12px;
        letter-spacing: 1.25px;
        line-height: 14.5px;
        color: #ffffff;      
    }
    }
    `}
</style>
</>
    )
  }
}